import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'sistema/paginas',
		component: Base,
		children: [
			{
				path: '',
				name: 'PaginasList',
				component: List,
				meta: {
					path: '/sistema/paginas',
					pai: 'Sistema',
					title: 'Admin - Páginas',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Páginas',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PaginasNovo',
				component: Form,
				meta: {
					path: '/sistema/paginas',
					pai: 'Sistema',
					title: 'Admin - Páginas - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Páginas',
						class: '',
						active: false,
						url: '/sistema/paginas'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PaginasEditar',
				component: Form,
				meta: {
					path: '/sistema/paginas',
					pai: 'Sistema',
					title: 'Admin - Páginas - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Páginas',
						class: '',
						active: false,
						url: '/sistema/paginas'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]